import {CALL_API} from 'redux-api-middleware';
import {
  API_SUBAWARDREC_GET_REQUEST,
  API_SUBAWARDREC_GET_SUCCESS,
  API_SUBAWARDREC_GET_FAILURE,
} from 'common/types';

import {commonJwtHeader} from 'common/utils';
import {ENDPOINT_DYNAMIC_DATA} from 'common/endpoints';

export default {
  getSubAwardRecommendation: (token, grantId, subgrantId) => {
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_DYNAMIC_DATA}entities/first-entity?entityType=subAwardRecommendation&grantId=${grantId}&subGrantId=${subgrantId}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [
          API_SUBAWARDREC_GET_REQUEST,
          API_SUBAWARDREC_GET_SUCCESS,
          API_SUBAWARDREC_GET_FAILURE,
        ],
      },
    };
  },
};
